<template>
    <div class="content">

      <div class="main">
        <div class="filters">
          <FiltersBlockCargos />
        </div>
        <div>

        </div>
        <div v-if="!confirmTable">
          <CargosTable 
          :trips="trips" 
          :isLoading="isLoading"
          :waitConfirmCount="[].length"
          @changeTable="changeTable"
          @saveTmsTemplate="saveTmsTemplate" 
          @updateSpot="updateSpot"
          />
          <my-pagination
          :key="inputKey"
          :currentPage="currentPage"
          :totalPages="totalPages" 
          @pageChanged="pageChanged" />
        </div>
        <div v-else>
          <CargosTableConfirm 
          :trips="[]" 
          :isLoading="isLoading"
          @changeTable="changeTable"
          @confirmOrCancelTrip="confirmOrCancelTrip" 
          />
        </div>
      </div>

    </div>
</template>



<script>
import { useStore } from 'vuex'
import { computed,ref,onMounted,onBeforeUnmount } from 'vue'
// import TripsFilters from '@/pages/trip/components/TripsFilters'
import FiltersBlockCargos from '@/pages/trip/components/FiltersBlock'

import CargosTable from '@/pages/trip/components/CargosTable'
import CargosTableConfirm from '@/pages/trip/components/CargosTableConfirm'
import FileDownloader from '@/pages/trip/components/FileDownloader.vue'
import ApiConnector from '@/backend/apiModels/taskApi'
import {reloadTrip} from '@/hooks/timerInterval'

export default {
  name: 'CargoList',
  components:{
    CargosTableConfirm,
    FiltersBlockCargos,
    FileDownloader,
    CargosTable
  },
  setup(){
    const store = useStore()
    const api = new ApiConnector()
    const activeReload = ref(true)
    const currentPage = computed(() => store.state.cargos.cargosPage.currentPage)
    const intervalId = reloadTrip(store,{func:'cargos/getCargos',params:{page:currentPage.value,silence:true}})
    const inputKey = ref(0)
    const confirmTable = ref(false)

    const forceRender = ()=>{
      inputKey.value += 1
    }

    onMounted(()=>{
      store.dispatch('cargos/getCargos',{page:currentPage.value})
    })

    onBeforeUnmount(() => {
      clearInterval(intervalId);
    });

    const updateTrips = async()=>{
      if(!activeReload.value) return
      activeReload.value = false
      const {response,request} = api.post('tms_orders')
      await request()
    }

    const updateSpot = async({trip_id,form})=>{
      await store.dispatch('cargos/updateTrip',{trip_id,form})
      
    }

    async function pageChanged(page){
      await store.dispatch('cargos/getCargos',{page})
      forceRender()
    }

    const saveTmsTemplate = async(ids)=>{
      store.dispatch('cargos/addTripTemlate',ids)
    }

    const changeTable = (isWait) =>{
      confirmTable.value = isWait
    }

    return{
      confirmTable,
      changeTable,
      forceRender,
      inputKey,
      updateSpot,
      updateTrips,
      activeReload,
      saveTmsTemplate,
      pageChanged,
      totalPages:computed(() => store.state.cargos.cargosPage.totalPages),
      currentPage,
      trips: computed(() => store.state.cargos.cargosPage.trips),
      isLoading:computed(() => store.state.cargos.cargosPage.loading),
    }
  },

};

</script>

<style scoped>

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 10px;
  margin-top: 25px;
}

.filters{
  margin-bottom: 10px;  
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.header-content{
  margin-top: 20px;
  margin-left: 20px;
}


</style>
